var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative max-w-10xl mx-auto" },
    [
      ["sm", "md"].includes(_vm.$mq)
        ? _c("responsive-image", {
            staticClass: "md_hidden",
            attrs: {
              sizes: "(min-width: 768px) 0px, 100vw",
              "image-object": _vm.headerMobileImg,
              "alt-text":
                "Thousands of designs to choose from, express yourself. Shop now."
            }
          })
        : _c("responsive-image", {
            attrs: {
              sizes: "(min-width: 768px) 100vw, 0px",
              "image-object": _vm.headerImg,
              "alt-text":
                "Thousands of designs to choose from, express yourself. Shop now."
            }
          }),
      _c(
        "div",
        { staticClass: "absolute absolute--center md_text-center" },
        [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass:
                "font-monoton leading-none mt-1 text-8xl xl_text-10xl text-brand leading-tight md_leading-none md_text-brand-secondary-900 md_mt-_5"
            },
            [_vm._v("Express")]
          ),
          _c(
            "div",
            {
              staticClass:
                "font-monoton leading-none text-8xl xl_text-10xl text-brand leading-tight md_leading-none md_text-brand-secondary-900"
            },
            [_vm._v("Yourself")]
          ),
          _c("buyer-button", {
            staticClass: "mt-3 md_mt-1 xl_mt-1_5",
            attrs: { text: "SHOP NOW" },
            nativeOn: {
              click: function($event) {
                return _vm.$router.push({ name: "marketplace" })
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.$router.push({ name: "marketplace" })
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "text-3xl text-white md_text-lg xl_text-3xl md_text-brand-secondary-900 leading-tight mb-1"
      },
      [
        _vm._v("Thousands of Designs "),
        _c("div", { staticClass: "block md_inline-block" }, [
          _vm._v("to Choose from")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }